// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.graph-node {
  position: absolute;
  width: 180px;
  min-height: 70px;
  background: white;
  border: 2px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  pointer-events: all;
  z-index: 10;
}

.graph-node:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.graph-node.active {
  border-width: 4px !important;
  border-color: #4A90E2 !important;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);
  box-shadow: 
    0 0 0 6px rgba(74, 144, 226, 0.4),
    0 0 20px rgba(74, 144, 226, 0.6),
    0 4px 16px rgba(74, 144, 226, 0.3);
  animation: activePulse 1.2s ease-in-out infinite;
  transform: scale(1.05);
  z-index: 20;
}

.graph-node.processing {
  border-width: 4px !important;
  border-color: #4A90E2 !important;
  box-shadow: 
    0 0 0 6px rgba(74, 144, 226, 0.4),
    0 0 20px rgba(74, 144, 226, 0.6),
    0 4px 16px rgba(74, 144, 226, 0.3);
  animation: processingPulse 1s ease-in-out infinite;
  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);
  transform: scale(1.05);
  z-index: 20;
}

@keyframes processingPulse {
  0%, 100% {
    box-shadow: 
      0 0 0 6px rgba(74, 144, 226, 0.4),
      0 0 20px rgba(74, 144, 226, 0.6),
      0 4px 16px rgba(74, 144, 226, 0.3);
    transform: scale(1.05);
  }
  50% {
    box-shadow: 
      0 0 0 10px rgba(74, 144, 226, 0.3),
      0 0 30px rgba(74, 144, 226, 0.8),
      0 6px 20px rgba(74, 144, 226, 0.4);
    transform: scale(1.08);
  }
}

@keyframes activePulse {
  0%, 100% {
    box-shadow: 
      0 0 0 6px rgba(74, 144, 226, 0.4),
      0 0 20px rgba(74, 144, 226, 0.6),
      0 4px 16px rgba(74, 144, 226, 0.3);
    transform: scale(1.05);
  }
  50% {
    box-shadow: 
      0 0 0 10px rgba(74, 144, 226, 0.3),
      0 0 30px rgba(74, 144, 226, 0.8),
      0 6px 20px rgba(74, 144, 226, 0.4);
    transform: scale(1.08);
  }
}

.graph-node.completed {
  border-color: #50C878;
}

.graph-node.error {
  border-color: #E74C3C;
}

.node-status-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  z-index: 11;
}

.node-status-indicator.active {
  background: #4A90E2;
  box-shadow: 
    0 0 12px rgba(74, 144, 226, 1),
    0 0 20px rgba(74, 144, 226, 0.8);
  animation: blink 0.8s ease-in-out infinite;
  width: 16px;
  height: 16px;
  border: 2px solid #FFF;
}

.node-status-indicator.completed {
  background: #50C878;
}

.node-status-indicator.error {
  background: #E74C3C;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.node-header {
  padding: 8px;
  border-radius: 6px 6px 0 0;
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 1;
}

.graph-node.active .node-header,
.graph-node.processing .node-header {
  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%) !important;
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.4);
}

.node-body {
  padding: 8px;
}

.node-label {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  text-align: center;
}

.node-meta {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.node-last-message {
  font-size: 11px;
  color: #999;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #eee;
  font-style: italic;
  line-height: 1.4;
}

`, "",{"version":3,"sources":["webpack://./src/graph_components/GraphNode.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,0EAA0E;EAC1E;;;sCAGoC;EACpC,gDAAgD;EAChD,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC;;;sCAGoC;EACpC,kDAAkD;EAClD,0EAA0E;EAC1E,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE;;;wCAGoC;IACpC,sBAAsB;EACxB;EACA;IACE;;;wCAGoC;IACpC,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;;;wCAGoC;IACpC,sBAAsB;EACxB;EACA;IACE;;;wCAGoC;IACpC,sBAAsB;EACxB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB;;oCAEkC;EAClC,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,wEAAwE;EACxE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".graph-node {\n  position: absolute;\n  width: 180px;\n  min-height: 70px;\n  background: white;\n  border: 2px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  pointer-events: all;\n  z-index: 10;\n}\n\n.graph-node:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.graph-node.active {\n  border-width: 4px !important;\n  border-color: #4A90E2 !important;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);\n  box-shadow: \n    0 0 0 6px rgba(74, 144, 226, 0.4),\n    0 0 20px rgba(74, 144, 226, 0.6),\n    0 4px 16px rgba(74, 144, 226, 0.3);\n  animation: activePulse 1.2s ease-in-out infinite;\n  transform: scale(1.05);\n  z-index: 20;\n}\n\n.graph-node.processing {\n  border-width: 4px !important;\n  border-color: #4A90E2 !important;\n  box-shadow: \n    0 0 0 6px rgba(74, 144, 226, 0.4),\n    0 0 20px rgba(74, 144, 226, 0.6),\n    0 4px 16px rgba(74, 144, 226, 0.3);\n  animation: processingPulse 1s ease-in-out infinite;\n  background: linear-gradient(135deg, #E8F4FD 0%, #F0F8FF 50%, #FFFFFF 100%);\n  transform: scale(1.05);\n  z-index: 20;\n}\n\n@keyframes processingPulse {\n  0%, 100% {\n    box-shadow: \n      0 0 0 6px rgba(74, 144, 226, 0.4),\n      0 0 20px rgba(74, 144, 226, 0.6),\n      0 4px 16px rgba(74, 144, 226, 0.3);\n    transform: scale(1.05);\n  }\n  50% {\n    box-shadow: \n      0 0 0 10px rgba(74, 144, 226, 0.3),\n      0 0 30px rgba(74, 144, 226, 0.8),\n      0 6px 20px rgba(74, 144, 226, 0.4);\n    transform: scale(1.08);\n  }\n}\n\n@keyframes activePulse {\n  0%, 100% {\n    box-shadow: \n      0 0 0 6px rgba(74, 144, 226, 0.4),\n      0 0 20px rgba(74, 144, 226, 0.6),\n      0 4px 16px rgba(74, 144, 226, 0.3);\n    transform: scale(1.05);\n  }\n  50% {\n    box-shadow: \n      0 0 0 10px rgba(74, 144, 226, 0.3),\n      0 0 30px rgba(74, 144, 226, 0.8),\n      0 6px 20px rgba(74, 144, 226, 0.4);\n    transform: scale(1.08);\n  }\n}\n\n.graph-node.completed {\n  border-color: #50C878;\n}\n\n.graph-node.error {\n  border-color: #E74C3C;\n}\n\n.node-status-indicator {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  z-index: 11;\n}\n\n.node-status-indicator.active {\n  background: #4A90E2;\n  box-shadow: \n    0 0 12px rgba(74, 144, 226, 1),\n    0 0 20px rgba(74, 144, 226, 0.8);\n  animation: blink 0.8s ease-in-out infinite;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #FFF;\n}\n\n.node-status-indicator.completed {\n  background: #50C878;\n}\n\n.node-status-indicator.error {\n  background: #E74C3C;\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.node-header {\n  padding: 8px;\n  border-radius: 6px 6px 0 0;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n  z-index: 1;\n}\n\n.graph-node.active .node-header,\n.graph-node.processing .node-header {\n  background: linear-gradient(135deg, #4A90E2 0%, #357ABD 100%) !important;\n  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.4);\n}\n\n.node-body {\n  padding: 8px;\n}\n\n.node-label {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.node-meta {\n  font-size: 12px;\n  color: #666;\n  margin-top: 4px;\n}\n\n.node-last-message {\n  font-size: 11px;\n  color: #999;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid #eee;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
